import Cookie from "js-cookie";

document.addEventListener('DOMContentLoaded', e => {

  const cookieWarningEl = document.querySelector("#cookie-warning");
  const cookieWarningCookieName = "cookie-warning-accepted";

  if (!Cookie.get(cookieWarningCookieName)) {
    cookieWarningEl.classList.add("show");
    const cookieWarningButtonEl = cookieWarningEl.querySelector("button");
    cookieWarningButtonEl.addEventListener("click", () => {
      Cookie.set(cookieWarningCookieName, "true", { expires: 365 });
      cookieWarningEl.classList.remove("d-flex");
      cookieWarningEl.classList.add("d-none");

    });
  }else{
    cookieWarningEl.classList.add("d-none");
    cookieWarningEl.classList.remove('d-flex')
  }

})
